import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { Spinner } from "../../Utils/Loaders";
import { getHistoryFile, removeAttachment } from "../../../api/clinicalTrial";
import { attachmentEntityType } from "../../../variables/Enums";
import { decodeFileName } from "../../Utils/Commons";

const FileHistoryModal = ({
  show,
  onClose,
  typeId,
  attachmentCategoryId,
  entityId,
}) => {
  const { t } = useTranslation();
  const [fileList, setFileList] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!show || !typeId) return;

    if (
      (typeId === attachmentEntityType.Startup ||
        typeId === attachmentEntityType.Practitioner ||
        typeId === attachmentEntityType.RegulatorySubmissions) &&
      !entityId
    ) {
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getHistoryFile(
          typeId,
          attachmentCategoryId || 0,
          entityId
        );
        setFileList(response.data);
      } catch (err) {
        console.error("Error cargando historial", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [show, typeId, attachmentCategoryId, entityId]);

  const handleDeleteFile = async (attachmentId) => {
    try {
      await removeAttachment(typeId, attachmentId);
      setFileList((prev) =>
        prev.filter((file) => file.attachmentId !== attachmentId)
      );
    } catch (err) {
      toast.error("errors.serverError");
    }
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t("attachments.history.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading || !fileList ? (
          <div className="text-center">
            <Spinner />
          </div>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>{t("attachments.history.nameLabel")}</th>
                <th>{t("attachments.history.dateLabel")}</th>
                <th>{t("attachments.history.actionsLabel")}</th>
              </tr>
            </thead>
            <tbody>
              {fileList.length > 0 ? (
                fileList.map((file, index) => (
                  <tr key={file.attachmentId}>
                    <td>{decodeFileName(file.fileName)}</td>
                    <td>{new Date(file.date).toLocaleString()}</td>
                    <td>
                      {index != fileList.length - 1 && (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#dc3545",
                            fontSize: "16px",
                          }}
                          onClick={() => handleDeleteFile(file.attachmentId)}
                          title="Eliminar archivo"
                        >
                          <i className="fa fa-trash" />
                        </span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center">
                    {t("attachments.history.noVersionsAvailable")}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileHistoryModal;
